class ReduceAnimations {
	constructor() {
		window.reduceAnimations = this.getReduceAnimationsVal();

		document.addEventListener('DOMContentLoaded', () => {
			const reduceAnimationsTrigger = document.getElementById('reduce-animations-input');

			if (window.reduceAnimations) {
				document.body.classList.add('prefers-reduced-motion');
			}

			if (null !== reduceAnimationsTrigger) {
				reduceAnimationsTrigger.checked = true;
				reduceAnimationsTrigger.addEventListener('change', this.handleTriggerChange);
			}
		});
	}

	getReduceAnimationsVal() {
		let reduceAnimations = localStorage.getItem('reduceAnimations');

		if (null === reduceAnimations) {
			reduceAnimations = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		}

		return 'true' === reduceAnimations || true === reduceAnimations;
	}

	handleTriggerChange() {
		window.reduceAnimations = !window.reduceAnimations;
		document.body.classList.toggle('prefers-reduced-motion', window.reduceAnimations);
		localStorage.setItem('reduceAnimations', window.reduceAnimations);

		const event = new CustomEvent('prefers-reduced-motion', {
			detail: {
				reduceAnimations: window.reduceAnimations,
			},
		});
		document.dispatchEvent(event);
	}
}

new ReduceAnimations();
